import asset0 from "@/assets/approved-final/home-hero-corporate-v2-1200.webp";
import asset1 from "@/assets/approved-final/home-iso-card-corporate-v1-1200.webp";
import asset2 from "@/assets/approved-final/home-iso-card-corporate-v1-desktop.webp";
import asset3 from "@/assets/approved-final/home-iso-card-corporate-v1-mobile.webp";
import asset4 from "@/assets/approved-final/home-registration-card-corporate-v1-1200.webp";
import asset5 from "@/assets/approved-final/home-registration-card-corporate-v1-desktop.webp";
import asset6 from "@/assets/approved-final/home-registration-card-corporate-v1-mobile.webp";
import asset7 from "@/assets/approved-final/about-workshop-v2-1200.webp";
import asset8 from "@/assets/approved-final/contact-conversation-v1-1200.webp";
import asset9 from "@/assets/approved-final/industries-corporate-v1-1200.webp";
import asset10 from "@/assets/approved-final/services-iso-corporate-v2-1200.webp";
import asset11 from "@/assets/approved-final/services-registration-corporate-v1-1200.webp";
import asset12 from "@/assets/approved-final/iso-9001-corporate-v4-1200.webp";
import asset13 from "@/assets/approved-final/iso-14001-corporate-v3-1200.webp";
import asset14 from "@/assets/approved-final/iso-45001-corporate-v3-1200.webp";
import asset15 from "@/assets/approved-final/iso-22000-food-process-v2-1200.webp";
import asset16 from "@/assets/approved-final/iso-27001-secure-infrastructure-v1-1200.webp";
import asset17 from "@/assets/approved-final/iso-29001-supplier-quality-team-v2-1200.webp";
import asset18 from "@/assets/approved-final/ministry-registration-team-v2-1200.webp";
import asset19 from "@/assets/approved-final/oil-gas-registration-team-v1-1200.webp";
import asset20 from "@/assets/approved-final/insight-quotation-corporate-v1-1200.webp";
import asset21 from "@/assets/approved-final/insight-verification-corporate-v1-1200.webp";
import asset22 from "@/assets/approved-final/basra-registration-corporate-v1-1200.webp";

export interface PageImage {
  src: string;
  width: number;
  height: number;
  objectPosition: string;
  alt: { en: string; ar: string };
  desktop?: { src: string; width: number; height: number };
  mobile?: { src: string; width: number; height: number };
}
const images: Record<string, PageImage> = {
  "/#hero": {
    src: asset0,
    width: 1200,
    height: 800,
    objectPosition: "50% 50%",
    alt: {
      en: "Illustrative scene: Corporate team reviewing documented processes with an advisor.",
      ar: "صورة توضيحية لفريق شركة يراجع عمليات موثّقة مع مستشار.",
    },
  },
  "/#iso-choice": {
    src: asset1,
    width: 1200,
    height: 800,
    objectPosition: "50% 50%",
    alt: {
      en: "Illustrative scene: Two colleagues reviewing business processes on a tablet.",
      ar: "صورة توضيحية لزميلين يراجعان إجراءات العمل باستخدام جهاز لوحي.",
    },
    desktop: { src: asset2, width: 450, height: 648 },
    mobile: { src: asset3, width: 680, height: 330 },
  },
  "/#registration-choice": {
    src: asset4,
    width: 1200,
    height: 400,
    objectPosition: "50% 50%",
    alt: {
      en: "Illustrative scene: Two business colleagues reviewing a supplier document pack.",
      ar: "صورة توضيحية لزميلين في العمل يراجعان حزمة وثائق مورد.",
    },
    desktop: { src: asset5, width: 1184, height: 290 },
    mobile: { src: asset6, width: 680, height: 330 },
  },
  "/about#hero": {
    src: asset7,
    width: 1200,
    height: 800,
    objectPosition: "50% 50%",
    alt: {
      en: "Illustrative scene: Colleagues discussing process and checklist cards in a workshop.",
      ar: "صورة توضيحية لزملاء يناقشون مخططات العمليات وقوائم التحقق في ورشة عمل.",
    },
  },
  "/contact#hero": {
    src: asset8,
    width: 1200,
    height: 800,
    objectPosition: "50% 50%",
    alt: {
      en: "Illustrative scene: A business advisor welcoming a company representative for a conversation.",
      ar: "صورة توضيحية لمستشار أعمال يرحّب بممثل شركة لإجراء محادثة.",
    },
  },
  "/industries#hero": {
    src: asset9,
    width: 1200,
    height: 800,
    objectPosition: "50% 50%",
    alt: {
      en: "Illustrative scene: A cross-functional corporate group discussing business operations.",
      ar: "صورة توضيحية لفريق شركة من اختصاصات متعددة يناقش العمليات التشغيلية.",
    },
  },
  "/services#iso-group": {
    src: asset10,
    width: 1200,
    height: 800,
    objectPosition: "50% 50%",
    alt: {
      en: "Illustrative scene: Advisor and operations manager mapping processes and responsibilities.",
      ar: "صورة توضيحية لمستشار ومدير عمليات يحددان العمليات والمسؤوليات.",
    },
  },
  "/services#registration-group": {
    src: asset11,
    width: 1200,
    height: 800,
    objectPosition: "50% 50%",
    alt: {
      en: "Illustrative scene: Administrator and advisor cross-checking supplier documents.",
      ar: "صورة توضيحية لمسؤول إداري ومستشار يدققان وثائق الموردين معاً.",
    },
  },
  "/services/iso-9001#hero": {
    src: asset12,
    width: 1200,
    height: 800,
    objectPosition: "50% 50%",
    alt: {
      en: "Illustrative scene: Corporate team reviewing service processes, responsibilities and performance.",
      ar: "صورة توضيحية لفريق شركة يراجع عمليات تقديم الخدمات والمسؤوليات والأداء.",
    },
  },
  "/services/iso-14001#hero": {
    src: asset13,
    width: 1200,
    height: 800,
    objectPosition: "50% 50%",
    alt: {
      en: "Illustrative scene: Advisor and facilities manager reviewing office energy and resource controls.",
      ar: "صورة توضيحية لمستشار ومدير مرافق يراجعان ضوابط استخدام الطاقة والموارد في المكتب.",
    },
  },
  "/services/iso-45001#hero": {
    src: asset14,
    width: 1200,
    height: 800,
    objectPosition: "50% 50%",
    alt: {
      en: "Illustrative scene: Corporate colleagues reviewing safe access and workplace evacuation planning.",
      ar: "صورة توضيحية لزملاء في شركة يراجعون سلامة الوصول وخطط الإخلاء في مكان العمل.",
    },
  },
  "/services/iso-22000#hero": {
    src: asset15,
    width: 1200,
    height: 800,
    objectPosition: "50% 50%",
    alt: {
      en: "Illustrative scene: A gloved operator checking a food sample temperature at a hygienic station.",
      ar: "صورة توضيحية لعامل يرتدي قفازات ويفحص درجة حرارة عينة غذائية في محطة عمل صحية.",
    },
  },
  "/services/iso-27001#hero": {
    src: asset16,
    width: 1200,
    height: 800,
    objectPosition: "50% 50%",
    alt: {
      en: "Illustrative scene: Controlled-entry doorway and orderly enterprise server racks.",
      ar: "صورة توضيحية لمدخل خاضع للتحكم وصفوف مرتّبة من خوادم مؤسسة.",
    },
  },
  "/services/iso-29001#hero": {
    src: asset17,
    width: 1200,
    height: 800,
    objectPosition: "50% 50%",
    alt: {
      en: "Illustrative scene: Supplier-quality team reviewing operational evidence at a service workshop.",
      ar: "صورة توضيحية لفريق جودة الموردين يراجع أدلة العمل التشغيلي في ورشة خدمات.",
    },
  },
  "/services/ministry-of-oil-vendor-registration#hero": {
    src: asset18,
    width: 1200,
    height: 800,
    objectPosition: "50% 50%",
    alt: {
      en: "Illustrative scene: Advisors preparing a supplier evidence plan with a company representative.",
      ar: "صورة توضيحية لمستشارين يضعون خطة لوثائق مورد مع ممثل الشركة.",
    },
  },
  "/services/oil-gas-registration#hero": {
    src: asset19,
    width: 1200,
    height: 800,
    objectPosition: "50% 50%",
    alt: {
      en: "Illustrative scene: Advisors and contractor manager discussing readiness during a site walk.",
      ar: "صورة توضيحية لمستشارين ومدير شركة مقاولات يناقشون الجاهزية خلال جولة ميدانية.",
    },
  },
  "/insights/compare-iso-certification-quotes-iraq#editorial": {
    src: asset20,
    width: 1200,
    height: 800,
    objectPosition: "50% 50%",
    alt: {
      en: "Illustrative scene: Procurement colleagues comparing three proposal scopes.",
      ar: "صورة توضيحية لزملاء في المشتريات يقارنون نطاقات ثلاثة عروض.",
    },
  },
  "/insights/accredited-vs-non-accredited-iso-certificate#editorial": {
    src: asset21,
    width: 1200,
    height: 800,
    objectPosition: "50% 50%",
    alt: {
      en: "Illustrative scene: Advisor and compliance manager verifying information at a workstation.",
      ar: "صورة توضيحية لمستشار ومدير امتثال يتحققان من المعلومات باستخدام حاسوب مكتبي.",
    },
  },
  "/services/oil-gas-registration/basra-oil-company#editorial": {
    src: asset22,
    width: 1200,
    height: 800,
    objectPosition: "50% 50%",
    alt: {
      en: "Illustrative scene: Supplier-readiness colleagues coordinating company registration documents.",
      ar: "صورة توضيحية لزملاء مختصين بجاهزية الموردين ينسقون وثائق تسجيل شركة.",
    },
  },
};
export function getPageImage(route: string, slot = "hero"): PageImage {
  const image = images[`${route}#${slot}`];
  if (!image) throw new Error(`Missing approved image: ${route}#${slot}`);
  return image;
}
